/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DocumentQueryFilterDto { 
    type?: DocumentQueryFilterDto.TypeEnum;
    dateRange?: DocumentQueryFilterDto.DateRangeEnum;
    showUnreadOnly?: boolean;
}
export namespace DocumentQueryFilterDto {
    export type TypeEnum = 'PRAEMIE' | 'VERTRAG' | 'AUSZAHLUNG' | 'MITTEILUNG' | 'JAHRESINFO' | 'ALLE';
    export const TypeEnum = {
        PRAEMIE: 'PRAEMIE' as TypeEnum,
        VERTRAG: 'VERTRAG' as TypeEnum,
        AUSZAHLUNG: 'AUSZAHLUNG' as TypeEnum,
        MITTEILUNG: 'MITTEILUNG' as TypeEnum,
        JAHRESINFO: 'JAHRESINFO' as TypeEnum,
        ALLE: 'ALLE' as TypeEnum
    };
    export type DateRangeEnum = 'THIS_MONTH' | 'LAST_MONTH' | 'LAST_3_MONTH' | 'THIS_YEAR' | 'LAST_YEAR' | 'ALL_YEARS';
    export const DateRangeEnum = {
        THIS_MONTH: 'THIS_MONTH' as DateRangeEnum,
        LAST_MONTH: 'LAST_MONTH' as DateRangeEnum,
        LAST_3_MONTH: 'LAST_3_MONTH' as DateRangeEnum,
        THIS_YEAR: 'THIS_YEAR' as DateRangeEnum,
        LAST_YEAR: 'LAST_YEAR' as DateRangeEnum,
        ALL_YEARS: 'ALL_YEARS' as DateRangeEnum
    };
}


